import { ChooseVendorStrategy } from 'core/agency/Agency';

// 通知分類。wire 上是大寫 name 字串（BE 用 @Enumerated(EnumType.STRING)）
export enum SiteAnnouncementType {
  SYSTEM = 'SYSTEM',
  PROMOTION = 'PROMOTION'
}

// 通知時長。LIMITED 才有 duration 天數；PERMANENT 時 duration 未定義（BE 存 null）
export enum SiteAnnouncementDurationType {
  PERMANENT = 'PERMANENT',
  LIMITED = 'LIMITED'
}

// 各通知分類對應的列表頁路徑。用 Record 是為了新增分類時強制補上路徑（缺一個就編不過）
export const SITE_ANNOUNCEMENT_LIST_PATH: Record<SiteAnnouncementType, string> = {
  [SiteAnnouncementType.SYSTEM]: '/site-announcements/system',
  [SiteAnnouncementType.PROMOTION]: '/site-announcements/promotions'
};

export type SiteAnnouncement = {
  id: number;
  name: string;
  content: string;
  vendorNumbers?: string[];
  publishTime: string;
  status: SiteAnnouncementStatus;
  // PERMANENT 的通知 BE 存 null 且不送這個欄位；讀取端一律先讀 durationType，不得單獨解讀 duration
  duration: number | null;
  version: number;
  shouldResend: boolean;
  // 以下兩欄在相容期可能缺席（BE @JsonInclude(NON_NULL) 下是 undefined 而非 null），讀取端必須各自 fallback：
  // type → SYSTEM（backfill 用的值）；durationType → LIMITED（既有通知都有天數，語意上都是限時）
  type?: SiteAnnouncementType;
  durationType?: SiteAnnouncementDurationType;
};

// BE 的 ListDTO 是手抄欄位、不繼承，實際只送 type —— 沒有 duration / durationType / shouldResend
export type SiteAnnouncementListDTO = Omit<SiteAnnouncement, 'duration' | 'durationType' | 'shouldResend'> & {
  creator: string;
};

export type SiteAnnouncementFormData = {
  publishTime: string;
  name: string;
  content: string;
  duration: number;
  type: SiteAnnouncementType;
  durationType: SiteAnnouncementDurationType;
  vendorNumbers: string[];
  shouldResend: boolean;
  chooseVendorStrategy: ChooseVendorStrategy;
};

export type SiteAnnouncementCreateDTO = Omit<SiteAnnouncementFormData, 'chooseVendorStrategy' | 'shouldResend'>;
export type SiteAnnouncementUpdateDTO = {
  id: number;
  shouldResend: boolean;
} & SiteAnnouncementCreateDTO;

export enum SiteAnnouncementStatus {
  ACTIVE = 0,
  PUBLISHED = 1,
  UNPUBLISHED = 2,
  INACTIVE = 3,
  DELETED = 99
}
